module.exports = {
    appId: "21dd1c71-a432-4727-9e9d-82ef287eb99d",
    scopes: ["user.read", "calendars.read"],
    tenat: "common"
  };
  